import React from "react";

const SiteFooter = ({openLiuyaoPage, openBaziPage, openFengshuiPage, openQimenPage, openZhishikuPage }) => {
  return (
    <footer className="bg-white border-t border-gray-200 py-8 mt-12">
      <div className="max-w-6xl mx-auto px-4">
        <div className="flex flex-col md:flex-row justify-center items-center gap-12">
          {/* 左侧：版权与导航链接 */}
          <div className="flex flex-col items-center md:items-center text-center space-y-3">
            <p className="text-sm text-gray-700 font-medium">© 2025 「圆運」易学系统</p>
            
            <nav className="flex flex-row flex-nowrap md:flex-wrap overflow-x-auto justify-center md:justify-center gap-x-4 gap-y-2 text-sm w-full md:w-auto px-1 pb-1 scrollbar-hide">
              <a href="http://bazi.tryonebest.com/bazi/index" onClick={openBaziPage} className="text-indigo-600 hover:text-indigo-700 transition-colors whitespace-nowrap">
                八字排盘
              </a>
              <a href="http://liuyao.tryonebest.com/liuyao/index" onClick={openLiuyaoPage} className="text-indigo-600 hover:text-indigo-700 transition-colors whitespace-nowrap">
                六爻排盘
              </a>
              <a href="https://bazi.tryonebest.com/zeri/index" onClick={openFengshuiPage} className="text-indigo-600 hover:text-indigo-700 transition-colors whitespace-nowrap">
                择日·择时
              </a>
              <a href="https://bazi.tryonebest.com/qimen/index" onClick={openQimenPage} className="text-indigo-600 hover:text-indigo-700 transition-colors whitespace-nowrap">
                奇门遁甲
              </a>
              <a href="https://bazi.tryonebest.com/lunarcalendar" onClick={openZhishikuPage} className="text-indigo-600 hover:text-indigo-700 transition-colors whitespace-nowrap">
                每日运程
              </a>
              <a href="https://bazi.tryonebest.com/about" className="text-indigo-600 hover:text-indigo-700 transition-colors whitespace-nowrap">
                关于我们
              </a>
            </nav>
            
            <p className="text-xs text-gray-500">🌹 邮件反馈：jxc114@163.com</p>
          </div>

          {/* 右侧：二维码 */}
          <div className="flex flex-col items-center space-y-2">
            <div className="p-1 bg-white border border-gray-200 rounded-lg shadow-sm">
              <img 
                src="/qrcode_8.jpg" 
                alt="微信公众号二维码" 
                className="w-24 h-24 object-cover rounded"
                title="微信公众号"
              />
            </div>
            <span className="text-xs text-gray-500">关注公众号获取更多</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default SiteFooter;